import { Footer } from 'mm-ui-components';
import { useSelector } from 'react-redux';
import React from 'react';
import {
  getAppsSection,
  getBottomFooterBar,
  getLinksSection,
  getSocialSection,
} from '../../store/navigation/doubleHeader/footer-old/footer.selectors';

export const FooterConnected: React.FunctionComponent = () => {
  const linksSection = useSelector(getLinksSection);
  const oldSocialSection = useSelector(getSocialSection);
  const appsSection = useSelector(getAppsSection);
  const bottomFooterBar = useSelector(getBottomFooterBar);
  return <Footer {...{ linksSection, oldSocialSection, appsSection, bottomFooterBar }} />;
};
